import React from "react";
import PropTypes from "prop-types";

import { TariffDisplay } from "../Tariffs";

const RouteTariffDisplay = ({ route, onChange, readOnly = false }) => (
  <TariffDisplay
    endDate={route.EndDate}
    readOnly={readOnly}
    tariffRecIdRef={route.TariffRecIdRef}
    onChange={onChange}
  />
);

RouteTariffDisplay.propTypes = {
  route: PropTypes.object,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool
};
export default RouteTariffDisplay;
